export const getCustomFields = () =>
    `query getCustomFields {
      customFields {
        id
        name
        order
        type
      }
    }`;

export const createCustomField = () =>
    `mutation createCustomField($customField: CreateCustomFieldInput!) {
      createCustomField(
        customField: $customField
      )
    }`;

export const updateCustomField = () =>
    `mutation updateCustomField($id: ID!, $name: RenameCustomFieldInput!) {
      renameCustomField(
        id: $id
        name: $name
      )
    }`;

export const deleteCustomField = () =>
    `mutation deleteCustomField($id: ID!) {
      deleteCustomField(
        id: $id
      )
    }`;
